var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentCardTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.697266,
    y: 0.634766,
    width: 57.6055,
    height: 57.6055,
    rx: 8.86238,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1577_13687",
    transform: "scale(0.005)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1577_13687",
    width: 200,
    height: 200,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAIAAAAiOjnJAAAFOUlEQVR4nO3dv2pbZxyH8fNPYExIKWQIbalwbaTBIQQ6pKMRHrJ4kJdcgG8il9B7aHsBHeoMWTqYkEK6FSIKJj4GR/gCPHgRItY5p4NAGDmxLLdfv99z+nyGEDL9EI8OR8r704njr7+PgP9aEnoANBNhQYKwIEFYkCAsSBAWJAgLEoQFCcKCBGFBgrAgQViQICxIEBYkCAsShAUJwoIEYUGCsCBBWJAgLEgQFiQICxKEBQnCggRhQYKwIEFYkCAsSBAWJAgLEoQFCcKCBGFBgrAgQViQICxIEBYkCAsShAUJwoIEYUGCsCBBWJAgLEgQFiQICxKEBQnCgkQWeoDPitudbHs3aXfildXQs4RXjUfl6XE5zIvXL0PPciOx56N7014/29ohqauKfHDxy4+hp1gsje9/FXqGeXG709rdo6pPSh48jL/dKN+9DT3IAo73WMn6JlVdI2l34nYn9BQLOIaVbe2EHsFavLKarG+GnmIBx7C4XDWAY1hoAMKCBGFBgrAgQViQICxIEBYkCAsShAUJx7Cq8Sj0CPi3HMMqT49Dj+CuPDkMPcIClmEN89AjWKvGo8r+vecYVvH6ZZEPQk9hqhqPPnLQ79bKd2+roki++S7OWqFnMVLkg4vffvK/XEW2R5Nn0l4/9AguypPDWiQ15R4WasrxHgsNQFiQICxIEBYkfDehZ/xXnYIw/4ToG1ba6ydr3bT7ZPYv1Xg0XeD5P//lsiIfTA72PQsz/boh7fVbz56HnqIeLn7/1fAHHRzvseJ2h53Vm8u2dgzvFhzDyrZ32Vm9uXhlNdveDT3FPMewEr/3n7NqPDJ8xRxv3rlcLcXz5XK8YqEBCAsShAUJwoIEYUGCsCBBWJAgLEgQFiQcw2LFflmGr5hjWKzYL2X6NJTQU8xzDGtysG/4FnQ2OdgPPcI8y03o87MoTtKNR6HnqIFqPJq8eVUO/gw9yDzLsKKoGh6xYr/QdOPesKrI9mjyjOHZSB+ep92nHM9jXeb82uEajjfvaADCggRhQYKwIGF98z79SOj/0Me7Ua8fXvMNi+eNX+W8Uz/H9AvS1t6L7Idtvh2dkzx4mD5+Wn54H52fhZ5lAcd7rLjdufxbILjMc+/5KsewavHCBZR2n/j/h4RjWFyuFvL/QOMYFhqAsCBBWJAgLEgQFiQICxKEBQnCggRhQYKwIOEYFtuqDeAYluHCuBueYn8brNhfoxqPinzgf9bP8qAfK/afV54cXvAU+1urhkfF8d/xF1/G9+5zjnSqyAfFX39M9n8OPciNuK/Yo6Yc77HQAIQFCcKCBGFBgrAg4bsJHUVR3O4k65vJWrcc5m5/RlFk+CRmH75fN7T2XpjvgU1//5O8Psn0C1L/qqIoirNWuvGoKopqeBR6FjuO91hpr+9f1Uzr2fPQIzhyDCtZ64YeYTn+C+93zzGsGl2upvwX3u+eY1hoAMKCBGFBgrAgQViQICxIEBYkCAsShAUJwoKEY1hsqzaAY1iTN69Cj7AcjmRd5RhWeXJYo4tWkQ9Cj+DI8qDf+Vn54X36+Kn/DnSRD2qx8H73fI8mR1GU9vrJWjexPO1Unh7X5UFcQViHhfpyvMdCAxAWJAgLEoQFCcKCBGFBgrAgQViQICxIEBYkCAsShAUJwoIEYUGCsCBBWJAgLEgQFiQICxKEBQnCggRhQYKwIEFYkCAsSBAWJAgLEoQFCcKCBGFBgrAgQViQICxIEBYkCAsShAUJwoIEYUGCsCBBWJAgLEgQFiQICxKEBQnCggRhQYKwIEFYkPgHKny2Mh5wrk4AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCardTwo);
export default __webpack_public_path__ + "static/media/paymentCardTwo.1e646972a279e13a5abafd57d90dc13c.svg";
export { ForwardRef as ReactComponent };